import { ConfirmDialog } from "plos/src/components/ConfirmDialog";
import { useTranslation } from "react-i18next";

interface ConfirmSkipDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmSkipDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: ConfirmSkipDialogProps) => {
  const { t } = useTranslation("onboarding");

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onConfirm={onConfirm}
      onCancel={onCancel}
      label={t("cancel.label", "Cancel tutorial")}
      header={t("cancel.header", "Cancel team creation?")}
      message={t(
        "cancel.message",
        "If you leave now you will lose your current progress. You can start this tutorial again using the button below the pitch.",
      )}
      confirmButtonText={t("cancel.confirm", "Leave and stop creating my team")}
      cancelButtonText={t("cancel.continue", "Continue creating my team")}
    />
  );
};

export default ConfirmSkipDialog;
